<script setup lang="ts">
import { inject, ref } from "vue";
import { CriticalError, DeckError } from "@/utils/errors";
import { APP } from "@/stores/app";
import CloseIcon from "./assets/close.svg";

const appStore = inject(APP)!;

const name = ref<string>("");
const message = ref<string>("");
const visible = ref<boolean>(false);

window.addEventListener("unhandledrejection", (event) => {
  const error = event.reason;
  if (error instanceof DeckError && error.appInstance === appStore.instance) {
    if (import.meta.env.PROD) {
      // don't expose error messages to console when in production
      event.preventDefault();
    }

    if (appStore.dev && error instanceof CriticalError) {
      // in case of critical errors we want to display the error when in dev mode
      name.value = error.name;
      message.value = error.message;

      // enable message box visibility
      visible.value = true;
    }
  }
});

function hide() {
  visible.value = false;
}
</script>

<!-- I don't expect this to attempt to render -->
<template>
  <div class="deck-error" v-if="visible">
    <CloseIcon class="deck-error-close" @click="hide" />
    <h1>{{ name }}</h1>
    <p>{{ message }}</p>
  </div>
  <slot></slot>
</template>

<style scoped>
.deck-error {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 1000;
  background-color: rgba(45, 45, 45, 0.85);
  color: white;
  padding: 1em;
  max-width: 30%;
  text-align: left;
}

.deck-error-close {
  position: absolute;
  top: -0.7em;
  right: -0.7em;
  fill: white;
  cursor: pointer;
  transform: scale(0.6);

  &:active {
    transform: scale(0.5);
  }
}

h1 {
  font-size: 1.15em;
  margin: 0;
}

p {
  margin: 0;
}
</style>
